module.exports = __webpack_public_path__ + "sv.svg?b620d58e00f5ba252bc526a45750a9e6";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/4x3/sv.svg
// module id = 1385
// module chunks = 27